import React from "react";
import { Link } from "react-router-dom";
import { useBooking } from "../contexts/BookingContext";
import { ctas } from "../data/content";
type CtaButtonsProps = {
  className?: string;
  tone?: "onDark" | "onLight";
};
const styles = {
  onDark: {
    primary: "border-cream bg-cream text-espresso hover:border-bark hover:bg-bark hover:text-cream",
    secondary: "border-cream/80 text-cream hover:border-bark hover:bg-bark hover:text-cream"
  },
  onLight: {
    primary: "border-bark bg-bark text-cream hover:border-bark-deep hover:bg-bark-deep",
    secondary: "border-bark text-bark hover:bg-bark hover:text-cream"
  }
};
const base = "inline-flex items-center justify-center whitespace-nowrap rounded-full border px-8 py-4 text-sm uppercase tracking-[0.18em] transition-colors duration-150 md:px-5 md:py-3 md:text-xs md:tracking-[0.12em] lg:px-8 lg:py-4 lg:text-sm lg:tracking-[0.18em]";
export function CtaButtons({
  className = "",
  tone = "onDark"
}: CtaButtonsProps) {
  const {
    openBooking
  } = useBooking();
  const s = styles[tone];
  return <div className={`flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4 ${className}`} data-id="element-47" data-mp="1npn4c6gc3tkp">
      <button type="button" onClick={openBooking} className={`${base} ${s.primary}`} data-id="element-48" data-mp="1woigdz627xvx">
        {ctas.call.label}
      </button>
      <Link to={ctas.facebookPage} className={`${base} ${s.secondary}`} data-id="element-49" data-mp="1rp5sdb3gckrr">
        {ctas.facebook.label}
      </Link>
    </div>;
}